// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--UZpYC";
export var footerContainer = "Footer-module--footerContainer--WC8Ik";
export var image = "Footer-module--image--5AHOm";
export var heading = "Footer-module--heading--OGYAr";
export var alignFull = "Footer-module--alignFull--398WN";